/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";

const useTrilha = (formikRef, config = {}) => {
  const { salvarLocalStorage = false, chave } = config;
 const trilhaSelect = useSelect("trilha");
  const [trilha, setTrilha] = useState(0);
  const [fila, setFila] = useState(null);

  const [trilhas, setTrilhas] = useState([]);

  useEffect(() => {
    const fetchTrilhas = async () => {
      const trilhasArray = [];
      await db.trilhas.filter((a) => a.ativo).each((trilha) => {
        trilhasArray.push(trilha);
      });
      setTrilhas(trilhasArray);
    };

    fetchTrilhas();
  }, []);

  const optionsTrilha = useMemo(() => prepareForOptions(trilhas, ["nome"], "id"), [trilhas]);

  const trilhasObjId = useMemo(() => createTrilhaObj({ key: 'id', data: trilhas, prefix: "key-" }), [trilhas]);
  const trilhasObjCodigo = useMemo(() => createTrilhaObj({ key: 'codigo', data: trilhas, prefix: "" }), [trilhas]);
  const trilhasObjNome = useMemo(() => createTrilhaObj({ key: 'nome', data: trilhas, prefix: "" }), [trilhas]);

  function createTrilhaObj({ key = 'codigo', data = [], prefix = "" }) {
    if (Array.isArray(data)) {
      return data.reduce((acc, cur) => {
        acc[`${prefix}${cur[key]}`] = cur;
        return acc;
      }, {})
    }
    return {};
  }


  useEffect(() => {
    if (fila && optionsTrilha?.length > 0) {
      SetSelectTrilha(fila);
    }
  }, [optionsTrilha, fila])

  function onChangeTrilha(e) {
    trilhaSelect.upDateValue(e.value);
    trilhaSelect.upDateDefaultValue(e || "");
    formikRef?.current?.setFieldValue("trilhaId", e.value);
    if (salvarLocalStorage) {
      localStorage.setItem(chave, JSON.stringify(e));
    }
    setTimeout(() => formikRef?.current?.setFieldTouched("trilhaId", true));
    setTrilha(e.value);
  }

    useEffect(() => {
    if(salvarLocalStorage){
      const filialSalva = localStorage.getItem(chave);

      if (filialSalva) {
        const filialObj = JSON.parse(filialSalva);
        setTrilha(filialObj.value);
        onChangeTrilha(filialObj);
        setFila(filialObj.value);
      }
    }
  }, [])

  function SetSelectTrilha(id) {
    if (optionsTrilha?.length > 0) {
      const trilha = optionsTrilha.find(trilha => trilha.value === id);
      if (trilha)
        onChangeTrilha(trilha);
      setFila(null);
    } else {
      setFila(id);
    }
  }

  return {
    optionsTrilha,
    trilhas,
    onChangeTrilha,
    SetSelectTrilha,
    trilha,
    trilhaSelect,
    trilhasObjId,
    trilhasObjCodigo,
    trilhasObjNome
  };
}

export default useTrilha;